module.exports = __webpack_public_path__ + "img/mysticlove_hair.6d96daba.jpg";